
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/settings/[[...tab]]",
      function () {
        return require("private-next-pages/my-account/settings/[[...tab]].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/settings/[[...tab]]"])
      });
    }
  